import { inDebugMode } from "./debug";
import { getLocalStorageString } from "./localstorage";
var AlmadLogLevel;
(function (AlmadLogLevel) {
    AlmadLogLevel[AlmadLogLevel["Info"] = 0] = "Info";
    AlmadLogLevel[AlmadLogLevel["Warn"] = 1] = "Warn";
    AlmadLogLevel[AlmadLogLevel["Error"] = 2] = "Error";
    AlmadLogLevel[AlmadLogLevel["Debug"] = 3] = "Debug";
})(AlmadLogLevel || (AlmadLogLevel = {}));
function severityToString(severity) {
    switch (severity) {
        case AlmadLogLevel.Info:
            return "INFO";
        case AlmadLogLevel.Warn:
            return "WARN";
        case AlmadLogLevel.Error:
            return "ERROR";
        case AlmadLogLevel.Debug:
            return "DEBUG";
        default:
            return "UNKNOWN";
    }
}
const getTimestamp = () => {
    const today = new Date();
    const timestamp = `${today.getHours().toString().padStart(2, "0")}:${today
        .getMinutes()
        .toString()
        .padStart(2, "0")}:${today.getSeconds().toString().padStart(2, "0")}:${today
        .getMilliseconds()
        .toString()
        .padStart(3, "0")}`;
    return timestamp;
};
const logMessage = (namespace, severity, ...args) => {
    const loggingEnabled = inDebugMode() ||
        Number.parseInt(getLocalStorageString("almad_loglevel") ?? "-1", 10) >=
            severity;
    if (loggingEnabled && "console" in window) {
        // eslint-disable-next-line no-console
        console.log(`[${getTimestamp()}] adtech-stack | ${namespace} | ${severityToString(severity)}: ${args}`);
    }
};
function createLogger(namespace) {
    return {
        logInfo: (...args) => logMessage(namespace, AlmadLogLevel.Info, args),
        logWarn: (...args) => logMessage(namespace, AlmadLogLevel.Warn, args),
        logError: (...args) => logMessage(namespace, AlmadLogLevel.Error, args),
        logDebug: (...args) => logMessage(namespace, AlmadLogLevel.Debug, args),
    };
}
export { createLogger };
//# sourceMappingURL=logger.js.map